import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from './Icon';

const InputWrapper = styled.div`
  position: relative;
  width: fit-content;

  :focus,
  :focus-within {
    ${Icon} {
      color: var(--input-text);
    }
  }

  ${Icon} {
    top: 12px;
    left: 16px;
    position: absolute;
    height: 16px;
    width: 16px;
    color: var(--input-clear-icon-color);
  }
`;

export const Input = styled.input`
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--input);
  border-radius: 6px;
  color: var(--input-text);
  font-size: var(--regular);
  font-weight: var(--normal);
  height: 40px;
  outline: none;
  padding: 10px 14px;

  &::placeholder {
    color: var(--input);
  }

  &:focus {
    border: 1px solid;
    border-color: var(--input-focus);
  }

  &[readonly] {
    cursor: default;
  }

  &[disabled],
  &[readonly] {
    background-color: var(--input-disabled-bg);
    border: 1px solid var(--input-disabled-bg);
    color: var(--input-disabled);
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  &[type='number'] {
    appearance: textfield;
  }

  &[type='search'] {
    min-width: 256px;
    padding-left: 44px;
    padding-right: 8px;

    ::-webkit-search-cancel-button {
      appearance: none;
      background-color: var(--input-clear-icon-color);
      cursor: pointer;
      height: 10px;
      width: 10px;

      clip-path: polygon(
        20% 0%,
        0% 20%,
        30% 50%,
        0% 80%,
        20% 100%,
        50% 70%,
        80% 100%,
        100% 80%,
        70% 50%,
        100% 20%,
        80% 0%,
        50% 30%
      );
    }
  }

  ${({ error }) =>
    error &&
    `
      border-color: var(--danger-dark);
      color: var(--danger-dark);

      &:focus {
        border-color: var(--danger-dark);
      }
    `}
`;

export const SearchInput = styled(({ className, ...props }) => {
  return (
    <InputWrapper className={className}>
      <Icon icon="search" />
      <Input type="search" {...props} />
    </InputWrapper>
  );
})``;

SearchInput.displayName = 'SearchInput';

Input.propTypes = {
  error: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default Input;
